var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RowItemAligned',{staticClass:"row-item",attrs:{"labels":_vm.wallboxLabels,"values":_vm.wallboxValues,"editable":true,"last":""},on:{"edit":function($event){return _vm.$emit('edit-component', {
      component: 'WallboxEditComponent',
      location: 'technicalDetailsComponent',
      properties: {
        wallboxData: _vm.wallboxData,
        deviceUuid: _vm.deviceUuid,
      },
    })}}})}
var staticRenderFns = []

export { render, staticRenderFns }